export default "__VITE_ASSET__Btp$lo5Q__"